export default class ReceitaService {
  constructor(resource) {
    this._resource = resource;
  }

  buscaDadosCnpj(cnpj) {
    return this._resource
      .post(`${process.env.API_URL}soaWebServices/buscarCnpj`, {
        cnpj
      })
      .then(
        res => res.json(),
        err => {
          console.log(err);
          throw new Error(
            "Não foi possível realizar a busca na SOA WebServices."
          );
        }
      );
  }
}



// WEBPACK FOOTER //
// ./src/domain/protocolo/CnpjService.js